import React, { useEffect, useState } from 'react';
import './BackgroundSlideshow.css';

const images = [
  'https://miro.medium.com/v2/resize:fit:900/1*TY9uBBO9leUbRtlXmQBiug.png',
  "https://media.licdn.com/dms/image/v2/C4E12AQEBVCR2SpRr9g/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1625909824541?e=2147483647&v=beta&t=iICaga7TwG_PTWwKx1Cqqn_Nt8xHQmgdRsvmx2JIBoI",
  'https://miro.medium.com/v2/resize:fit:900/1*TY9uBBO9leUbRtlXmQBiug.png',
  'https://media.licdn.com/dms/image/v2/C4E12AQEBVCR2SpRr9g/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1625909824541?e=2147483647&v=beta&t=iICaga7TwG_PTWwKx1Cqqn_Nt8xHQmgdRsvmx2JIBoI'
];

const BackgroundSlideshow = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="slideshow-container">
      {images.map((image, index) => (
        <div
          key={index}
          className={`slide ${index === currentImageIndex ? 'active' : ''}`}
          style={{ backgroundImage: `url(${image})` }}
        ></div>
      ))}
    </div>
  );
};

export default BackgroundSlideshow;
